<template>
  <ContentWithHeader>
    <template #header>
      <div class="d-flex justify-content-between">
        <button
          class="btn no-bg"
          @click="setPosSection('choose-product')">
          <i class="fas fa-times"/>
        </button>
        <button
          class="btn no-bg"
          @click="openModal()">
          <i class="fas fa-user-plus"/>
        </button>
      </div>
    </template>
    <template #content>
      <div
        class="row mt-4 mb-3"
        style="margin-left: 0;margin-right: 0;">
        <div
          class="col-12 status">
          {{ $t('message.customerlist') }} ({{ customers.length }})
        </div>
        <div class="col-12 mt-2">
          <input
            :placeholder="$t('placeholder.search')"
            v-model="textSearch"
            type="text"
            class="form-control form-control-sm"
            style="float: right;">
        </div>
      </div>
      <ul class="col-12 no-padding items">
        <li
          v-if="customer_id"
          class="row no-margin item text-danger"
          @click="onSelectedCustomer({ customer_id: null, customer_new: false })">
          <span>
            <i
              class="fas fa-ban"
              style="margin-right: 7px;margin-left: 3px;font-size: 13px;"/>
            {{ $t('message.deselected') }}
          </span>
        </li>
        <li
          v-for="(item, index) in (searchResults.length > 0 ? searchResults : customers)"
          :class="[{active: item.customer_id == customer_id ? 'active' : ''}]"
          :key="index"
          class="row no-margin item"
          @click="onSelectedCustomer({ customer_id: item.customer_id, customer_new: false })">
          <div class="col">
            {{ item.customer_name }}
          </div>
        </li>
      </ul>

      <div
        id="createModal"
        class="modal"
        tabindex="-1"
        role="dialog"
        aria-hidden="true"
        data-keyboard="false"
        data-backdrop="static">
        <div
          class="modal-dialog modal-lg"
          role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">
                {{ $t('message.newcustomer') }}
              </h5>
              <button
                v-if="!$store.state.app.loading"
                type="button"
                class="close"
                aria-label="Close"
                @click="closeModal()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <section>
                <label>{{ $t('message.customername') }} *</label>
                <input
                  ref="name"
                  :class="[bindClass.name]"
                  v-model="form.name"
                  type="text"
                  class="form-control">
                <div class="invalid-feedback">
                  {{ $t('message.pleasefillcustomername') }}
                </div>
              </section>
              <section>
                <label>{{ $t('message.gender') }}</label>
                <select
                  v-model="form.gender"
                  class="custom-select">
                  <option value="">{{ $t('placeholder.select') }}</option>
                  <option value="m">{{ $t('message.male') }}</option>
                  <option value="f">{{ $t('message.female') }}</option>
                </select>
              </section>
              <section>
                <label>{{ $t('message.birthdate') }}</label>
                <BaseInputDatePicker
                  v-model="form.birthdate"
                />
              </section>
              <section>
                <label>{{ $t('message.email') }}</label>
                <input
                  v-model="form.email"
                  type="text"
                  class="form-control">
              </section>
              <section>
                <label>{{ $t('message.tel') }}</label>
                <input
                  v-model="form.tel"
                  type="text"
                  class="form-control">
              </section>
              <section>
                <label>{{ $t('message.note') }}</label>
                <textarea
                  v-model="form.note"
                  class="form-control"/>
              </section>
              <section>
                <vs-checkbox
                  v-model="form.checkAutoSelected"
                  style="float: left;margin: 0 5px 0 0;">
                  {{ $t('message.autoselectedthiscustomer') }}
                </vs-checkbox>
              </section>
            </div>
            <div
              v-if="!$store.state.app.loading"
              class="modal-footer">
              <button
                type="button"
                class="btn btn-light"
                @click="closeModal()">{{ $t('button.cancel') }}</button>
              <button
                type="button"
                class="btn btn-web"
                @click="save()">{{ $t('button.ok') }}</button>
            </div>
            <div
              v-if="$store.state.app.loading"
              class="modal-footer">
              <button
                type="button"
                class="btn btn-light"
                disabled>{{ $t('button.cancel') }}</button>
              <button
                type="button"
                class="btn btn-web"
                disabled>
                <i class="fas fa-spinner spin"/>
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </ContentWithHeader>
</template>

<script>
import customerListMixin from '@/mixins/pos/customerList'
import ContentWithHeader from '../common/ContentWithHeader.vue'

export default {
  mixins: [customerListMixin],

  components: {
    ContentWithHeader,
  },
}
</script>

<style scoped>
  .wrapper ul.items {
    overflow: auto;
  }
  .wrapper ul.items li.item {
    padding: 10px 15px;
    background: #fff;
    border-bottom: solid 1px #F2F2F2;
    cursor: pointer;
  }
  .wrapper ul.items li.item .col {
    padding: 0;
  }
  .wrapper ul.items li.item i.fa-circle {
    font-size: 8px;
    position: relative;
    top: -2px;
    margin-right: 12px;
    margin-left: 6px;
    color: #FF9800;
  }
  .wrapper ul.items li.item.available i.fa-circle {
    color: #8BC34A;
  }
</style>



// WEBPACK FOOTER //
// src/components/apps/pos/sale/mobile/include/CustomerList.vue